// Payments endpoints — Packet W2a. Thin wrappers; no behavior change.
import { api } from "../api";

export const createCheckoutSession = async (payload) =>
  (await api.post("/payments/create-checkout-session", payload)).data;

export const getPaymentStatus = async (sessionId) =>
  (await api.get(`/payments/status/${sessionId}`)).data;
